'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _ShareLinkButton = require('components/ShareLinkButton/ShareLinkButton');

var _ShareLinkButton2 = _interopRequireDefault(_ShareLinkButton);

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var RecipientShareLinkButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    getLinkLoading: state.statistics.getLinkLoading,
    linkData: state.statistics.getLinkData
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_PureComponent) {
  (0, _inherits3.default)(RecipientShareLinkButton, _PureComponent);

  function RecipientShareLinkButton() {
    (0, _classCallCheck3.default)(this, RecipientShareLinkButton);
    return (0, _possibleConstructorReturn3.default)(this, (RecipientShareLinkButton.__proto__ || (0, _getPrototypeOf2.default)(RecipientShareLinkButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecipientShareLinkButton, [{
    key: 'onClick',
    value: function onClick() {
      var _props = this.props,
          recipientId = _props.recipientId,
          projectId = _props.projectId,
          getLink = _props.getLink;

      getLink({ recipientId: recipientId, projectId: projectId });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          recipientId = _props2.recipientId,
          projectId = _props2.projectId,
          link = _props2.linkData.fileName;

      var linkUrl = link ? '' + _config2.default.app.urlParts.report + link : '';

      return _react2.default.createElement(_ShareLinkButton2.default, {
        className: className,
        onClick: this.onClick,
        id: 'share-recipient-link-' + recipientId + '-' + projectId,
        link: linkUrl
      });
    }
  }]);
  return RecipientShareLinkButton;
}(_react.PureComponent), _class3.propTypes = {
  className: _propTypes2.default.string,
  getLink: _propTypes2.default.func,
  linkData: _propTypes2.default.object,
  projectId: _propTypes2.default.number.isRequired,
  recipientId: _propTypes2.default.number.isRequired
}, _class3.defaultProps = {
  linkData: {},
  onClick: _noop3.default,
  projectId: 0,
  recipientId: 0
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onClick'), _class2.prototype)), _class2)) || _class);
exports.default = RecipientShareLinkButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/RecipientShareLinkButton/RecipientShareLinkButton.js
// module id = 848
// module chunks = 1